import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogDetailPage } from '@/features/data/catalog/catalog-detail-page';
import { catalogSearch } from '@/features/data/catalog/catalog-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Une table : vue d'ensemble (onglet par défaut), schéma, aperçu, statistiques, historique, lignage,
 * usages, définition (`catalog-tabs.ts`).
 */
export const Route = createFileRoute('/$tenant/catalog/$layer/$database/$table/')({
  validateSearch: catalogSearch,
  component: TableRoute,
});

function TableRoute() {
  const { tenant, layer, database, table } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[
        { label: t('nav.items.catalog') },
        { label: layer, mono: true },
        { label: database, mono: true },
        { label: table, mono: true },
      ]}
    >
      <CatalogDetailPage
        tenantId={tenant}
        path={{ level: 'table', layer, database, table }}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
